import { colorTextSecondary, ConfigProvider, Flex, Input, Typography } from '@arkestro/arkestro-design-system';
import { LockOutlined } from '@ant-design/icons';
import useTranslation from 'next-translate/useTranslation';
import { usePriceAgreement } from '@components/Agreements/api/usePriceAgreements';
import { InheritedBusinessUnitCaption } from './inherited-business-unit-caption';
import styles from './inherited-business-unit-field.module.scss';
import type { ID } from 'types';

interface InheritedBusinessUnitFieldProps {
  isAgreementLinked?: boolean;
  /** `undefined` while the event's agreement is still loading; `null` when it has none. */
  priceAgreementId: ID | null | undefined;
  storedBusinessUnit?: { name: string | null };
}

export const InheritedBusinessUnitField = ({
  isAgreementLinked = true,
  priceAgreementId,
  storedBusinessUnit,
}: InheritedBusinessUnitFieldProps) => {
  const { t } = useTranslation('common');
  const { data: agreement } = usePriceAgreement(priceAgreementId);

  const businessUnitName = storedBusinessUnit ? storedBusinessUnit.name : agreement?.business_unit?.name;
  const hasNoAgreement = priceAgreementId === null;

  return (
    <Flex gap={4} vertical>
      <Typography className={styles.label}>{t('rfx_drawer.business_unit_label')}</Typography>
      <ConfigProvider theme={{ components: { Input: { colorTextDisabled: colorTextSecondary } } }}>
        <Input
          aria-label={t('rfx_drawer.business_unit_label')}
          data-testid='inherited-business-unit'
          disabled
          placeholder={hasNoAgreement ? t('rfx_drawer.inherited_business_unit_placeholder') : undefined}
          suffix={<LockOutlined className={styles.lockIcon} />}
          value={businessUnitName ?? ''}
        />
      </ConfigProvider>
      <InheritedBusinessUnitCaption
        agreement={agreement}
        hasNoAgreement={hasNoAgreement}
        isAgreementLinked={isAgreementLinked}
      />
    </Flex>
  );
};
